// extracted by mini-css-extract-plugin
export var label = "_5o-1";
export var reminder = "_5o-0";